import { useTranslate } from 'hooks/useTranslate';
import { FC, useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';

import { Board, Document, SelectorOption } from 'types';
import UploadDocument from 'modules/documents/components/UploadDocument';
import { useGetDocuments } from 'modules/_shared/hooks/useGetDocuments';

type Props = {
  board: Board;
  documentFile: File | undefined;
  handleChangeDocumentFile: (file: File) => void; // eslint-disable-line
  handleChangeSelectedDocument: (option: any) => void; // eslint-disable-line
};

const getOptions = (documents: Document[]) => {
  const options = documents?.map((document) => ({
    value: document._id,
    label: document.name,
  }));

  return options;
};

const ReplaceTemplateWithDocumentModalBody: FC<Props> = ({
  board,
  documentFile,
  handleChangeSelectedDocument,
  handleChangeDocumentFile,
}: Props) => {
  const { t } = useTranslate();
  const animatedComponents = makeAnimated();

  const documentIds = useMemo(
    () => [
      ...(board?.attachedDocuments ?? []),
      ...(board?.privateDocuments ?? []),
    ],
    [board?.attachedDocuments, board?.privateDocuments]
  );

  const {
    data: { documents },
    isLoading,
  } = useGetDocuments({
    documentIds,
  });

  const [selectedOption, setSelectedOption] = useState<SelectorOption | null>(
    null
  );

  const handleChangeSelectedOption = (
    selectedOption: SelectorOption | null
  ) => {
    setSelectedOption(selectedOption);
    handleChangeSelectedDocument(selectedOption);
  };

  return (
    <>
      <Modal.Body>
        <span className="text-muted text-justify">
          {t('ReplaceBoardTemplateWithDocumentDescription')}
        </span>

        <div className="row my-4">
          <div className="col">
            <div className="form-group">
              <label className="form-label" htmlFor="board-template-select">
                {t('SelectDocument')}
              </label>

              <Select
                id="board-template-select"
                closeMenuOnSelect
                className="react-select-lg"
                value={!documentFile ? selectedOption : null}
                options={getOptions(documents)}
                components={animatedComponents}
                onChange={handleChangeSelectedOption as any}
                placeholder={t('Select')}
                isLoading={isLoading}
                loadingMessage={() => t('LoadingDocuments')}
                noOptionsMessage={() => t('NoDocumentsAvailable')}
              />
            </div>

            <UploadDocument
              file={documentFile}
              setFile={handleChangeDocumentFile}
              label="AddDocument"
              inputLabel={documentFile?.name}
            />
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default ReplaceTemplateWithDocumentModalBody;
